import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
} from "react-icons/fa";

import "./Footer.css";

export default function Footer() {
  return (
    <footer className="pro-footer">

      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-col branding">
          <h2 className="footer-title">SRI RAJALAKSHMI TRAVELS</h2>
          <p className="footer-tagline">Safe • Comfort • 24/7 Travel Service</p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-col">
          <h3 className="footer-head">Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/About">About Us</Link></li>
            <li><Link to="/Services">Services</Link></li>
            <li><Link to="/Gallery">Gallery</Link></li>
            <li><Link to="/Contact">Contact</Link></li>
            <li><Link to="/Privacy">Privacy&Policy</Link></li>
            <li><Link to="/Terms">Terms & Conditions</Link></li>
          </ul>
        </div>

        {/* CONTACT INFO */}
        <div className="footer-col">
          <h3 className="footer-head">Contact Us</h3>
          <p><FaPhoneAlt /> +91 9095223243</p>
          <p><FaEnvelope /> srirajalakshmitravels@gmail.com</p>
          <p><FaWhatsapp /> WhatsApp 24/7</p>
          <p><FaMapMarkerAlt /> Aruppukottai, Tamil Nadu</p>
        </div>

        {/* SOCIAL MEDIA */}
        <div className="footer-col">
          <h3 className="footer-head">Follow Us</h3>
          <div className="social-row">
            <a href="https://www.facebook.com/profile.php?id=61570304900604"><FaFacebookF /></a>
            <a href="https://www.instagram.com/sri_rajalakshmi_travels_aruppu/"><FaInstagram /></a>
         <a 
  href="https://wa.me/919095223243" 
  target="_blank" 
  rel="noopener noreferrer"><FaWhatsapp /></a>
          </div>
        </div>

      </div>

      {/* COPYRIGHT */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} SRI RAJALAKSHMI TRAVELS — All Rights Reserved
      </div>
    </footer>
  );
}
